module.exports = __webpack_public_path__ + "img/Flag_of_Iran.6d32f579.svg";